import { modalAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const helpers = createMultiStyleConfigHelpers(parts.keys)

const baseStyle = helpers.definePartsStyle({
  header: {
    fontFamily: 'heading',
    fontSize: 'xl',
    fontWeight: 'light',
  },
  dialog: {
    borderRadius: 'sm',
  },
  body: {
    py: 8,
  },
  closeButton: {
    borderRadius: 'sm',
    top: 2,
    right: 2,
  },
})

const variants = {
  main: helpers.definePartsStyle({}),
}

export default helpers.defineMultiStyleConfig({ baseStyle, variants })
